const CloudProviders = () => {
  const providers = [
    { name: "AWS", fullName: "Amazon Web Services", logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" },
    { name: "Azure", fullName: "Microsoft Azure", logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Microsoft_Azure.svg" },
    { name: "GCP", fullName: "Google Cloud Platform", logo: "https://hstengineer.lon1.digitaloceanspaces.com/messages/hst-ai-96c24bfd-6a33-42fd-8472-25776964aa20/attachments/4c669b40-0865-4e5d-a93d-1785d77d7087.png" },
    { name: "Others", fullName: "Any Cloud Provider", color: "bg-gradient-sunset" }
  ];

  return (
    <section className="py-10 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-left sm:text-center mb-8 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-ink-blue-900 mb-3 sm:mb-4 leading-[1.15]">
            Build Here. Host Anywhere.
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-soft-gray-600 max-w-4xl sm:mx-auto leading-relaxed">
            Your code and app is not stuck within the Joylo platform.
            Download your native cloud code container and deploy anywhere you like.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5 sm:gap-8 mb-8 sm:mb-12">
          {providers.map((provider, index) => (
            <div key={index} className="text-center">
              {provider.logo ? (
                <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-4 flex items-center justify-center">
                  <img
                    src={provider.logo}
                    alt={provider.name}
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              ) : (
                <div className={`w-14 h-14 sm:w-16 sm:h-16 ${provider.color} rounded-full flex items-center justify-center text-white text-xl sm:text-2xl font-bold mx-auto mb-3 sm:mb-4`}>
                  ⚡
                </div>
              )}
              <h3 className="font-semibold text-ink-blue-900 mb-1 sm:mb-2 text-sm sm:text-base">{provider.name}</h3>
              <p className="text-soft-gray-600 text-xs sm:text-sm">{provider.fullName}</p>
            </div>
          ))}
        </div>

        <div className="glass rounded-2xl p-5 sm:p-10 lg:p-12 text-center border border-warm-cream-300">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-5 sm:gap-8">
            <div className="flex flex-col items-center">
              <div className="w-9 h-9 sm:w-12 sm:h-12 mb-2 sm:mb-4 flex items-center justify-center">
                <img
                  src="https://www.docker.com/wp-content/uploads/2022/03/vertical-logo-monochromatic.png"
                  alt="Docker"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <h4 className="font-semibold text-ink-blue-900 mb-1 text-xs sm:text-base leading-snug">
                <span className="sm:hidden">Cloud Containers</span>
                <span className="hidden sm:inline">Native Cloud Containers</span>
              </h4>
              <p className="text-soft-gray-600 text-[11px] sm:text-sm leading-snug">Docker-ready</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-9 h-9 sm:w-12 sm:h-12 mb-2 sm:mb-4 flex items-center justify-center">
                <img
                  src="https://wiki.postgresql.org/images/a/a4/PostgreSQL_logo.3colors.svg"
                  alt="PostgreSQL"
                  className="max-w-full max-h-full object-contain"
                />
              </div>
              <h4 className="font-semibold text-ink-blue-900 mb-1 text-xs sm:text-base leading-snug">
                <span className="sm:hidden">Database Export</span>
                <span className="hidden sm:inline">PostgreSQL Database Export</span>
              </h4>
              <p className="text-soft-gray-600 text-[11px] sm:text-sm leading-snug">Full data portability</p>
            </div>
            <div className="flex flex-col items-center col-span-2 md:col-span-1">
              <div className="w-9 h-9 sm:w-12 sm:h-12 mb-2 sm:mb-4 flex items-center justify-center bg-warm-cream-200 rounded-lg">
                <svg className="w-5 h-5 sm:w-8 sm:h-8 text-soft-gray-600" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2L2 7v10c0 5.55 3.84 9.739 9 11 5.16-1.261 9-5.45 9-11V7l-10-5z"/>
                </svg>
              </div>
              <h4 className="font-semibold text-ink-blue-900 mb-1 text-xs sm:text-base leading-snug">Lift & Shift Ready</h4>
              <p className="text-soft-gray-600 text-[11px] sm:text-sm leading-snug">Zero vendor lock-in</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CloudProviders;